function load_more( caller ){
    var container = $($(caller).data('target'));
    var current_page = container.data('page') || 1;
    container.data('page' , current_page + 1);
    append_partial( container );
    $(caller).remove();
}

function wall_details(target){
    $('.wall-item-details').data('id', $(target).data('id') );
    window.history.pushState('page2', 'Title', $(target).attr('href') );
    load_partial($('.wall-item-details') , function(){
        $('.blitz-wall').hide();
        $('.wall-item-details').show();
    });
    return false;
}

function back_to_wall(target){
    if( $('.blitz-wall').length > 0 ){
        
        $('.blitz-wall').show();
        $('.wall-item-details').hide();

    }else{
        window.location = $(target).attr('href');
    }
    return false;
}
function viewUsersWall(id,label){
    $filterPartialSelector = '.users-filter-partial'
    $filterPartialElement = $($filterPartialSelector);

    $listPartialSelector = '.blitzwall-list'
    $listPartialElement = $($listPartialSelector);

    $('.filter-template .clear-btn').each(function(){
        Filters.softRemoveAllFilters($(this));
    });

    $template = `<div class="tag col-auto" data-filter-partial="${ $filterPartialSelector }" data-list-target="${$listPartialSelector}"  data-name="users" data-value="${id}">
                    ${ label }
                    <button type="button" class="close" onClick="Filters.tagsCheckboxCloseBtn($(this));"><svg width="8" height="8" viewBox="0 0 8 8"  xmlns="http://www.w3.org/2000/svg"><path d="M5.59977 4L8 6.40023L6.40023 8L4 5.59977L1.59977 8L0 6.40023L2.40023 4L0 1.59977L1.59977 0L4 2.40023L6.40023 0L8 1.59977L5.59977 4Z" /></svg></button>
                </div>`;
                $('.users-selected-filters .filter-template-content').empty();
    $('.users-selected-filters .filter-template-content').append($template);  
    $('.users-selected-filters').show();

   


    $filterPartialElement.data('selected_users',id)
    load_partial($filterPartialElement);

    $('.blitzwall-list').data('users',id)
    load_partial($('.blitzwall-list'),function(){
        scroll2position(0);
    });
    
}